import {Link, Stack, Typography} from "@mui/material"
import {useTheme} from "@mui/material/styles"
import {useNavigate} from "react-router-dom"
import LoginLayout from "../../layouts/login"
import AuthLoginForm from "./AuthLoginForm"
import {useLocales} from "../../locales"
import Logo from "../../components/logo"
import {useSettingsContext} from "../../components/settings"
import {login, requestDataDeletion} from "../../utils/translate/translateUtils"
import {PATH_DELETE_ACCOUNT} from "../../routes/paths"

export default function Login() {
    const {appName, companyName} = useSettingsContext()
    const navigate = useNavigate()
    const theme = useTheme()
    const {t} = useLocales()

    const handleRequestData = () => navigate(PATH_DELETE_ACCOUNT.delete, {replace: true})

    return (
        <LoginLayout>
            <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
            >
                <Logo/>
                <Typography
                    variant="h4"
                    color={theme.palette.primary.main}
                >
                    {`${appName} - ${companyName}`}
                </Typography>
            </Stack>

            <Stack
                spacing={2}
                sx={{mb: 5, position: "relative"}}
            >
                <Typography variant="h4">
                    {login(t)}
                </Typography>
            </Stack>

            <AuthLoginForm/>

            <Stack
                sx={{
                    position: "absolute",
                    bottom: 25,
                    right: {xs: 20, sm: 160, md: 65}
                }}
            >
                <Link
                    component="button"
                    variant="body2"
                    onClick={handleRequestData}
                    color="common.black"
                >
                    {requestDataDeletion(t)}
                </Link>
            </Stack>
        </LoginLayout>
    )
}